import { useCallback } from 'react';
import {
    GET_AUTH_API,
    GET_LIFF_LOGIN_API,
    GET_LOGIN_API,
    GET_LOGOUT_API,
    GET_ME_CHECK_API,
    GET_ME_API,
    GET_ME_UI_ROLE_API,
    GET_LIFF_AUTH_API,
    GET_LIFF_BINDING_API, 
    GET_LIFF_LOGIN_EMPLOYEE_API, 
} from './apiPath';
import { LOGIN_ROOT_ROUTER } from "@Router/routerPath";
import { useHistory } from 'react-router-dom';
import useAxios from '@Apis/useAxios';
import { localUser } from '@Util/utils';
// import useShowLoading from '@Util/hook/useShowLoading';
// import { parseDate, isValidDate } from '@Util/moment';

const useAuthApi = () => {
    const Axios = useAxios();
    const history = useHistory();

    const postAuthApi = useCallback(
        async (params, fn) => {
            const resp = await Axios.post(GET_AUTH_API, params, fn);
            return resp;
        },
        // eslint-disable-next-line
        []
    );
    
    const postLiffAuthApi = useCallback(
        async (params, fn) => {
            const resp = await Axios.post(GET_LIFF_AUTH_API, params, fn);
            return resp;
        },
        // eslint-disable-next-line
        []
    )
    
    const postLoginApi = useCallback(
        async (params, fn) => {
            const resp = await Axios.post(GET_LOGIN_API, params, fn);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const postLiffLoginApi = useCallback(
        async (params, fn) => {
            const resp = await Axios.post(GET_LIFF_LOGIN_API, params, fn);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const postLiffLoginEmployeeApi = useCallback(
        async (params, fn) => {
            const resp = await Axios.post(GET_LIFF_LOGIN_EMPLOYEE_API, params, fn);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const getLogoutApi = useCallback(
        async (fn) => {
            await Axios.get(
                GET_LOGOUT_API,
                {},
                {
                    callbackfn: (resultData, respBody) => {
                        const { success, statusCode } = respBody.data;
                        localUser.logout();
                        if (success && statusCode === '0000') {
                            history.push(LOGIN_ROOT_ROUTER);
                            window.location.reload();
                        } else {
                            alert('登出失敗，請重新整理畫面');
                        }
                        
                        if (typeof fn === 'function') fn();
                    },
                }
            );
        },
        // eslint-disable-next-line
        []
    );

    const getLiffBindingApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_LIFF_BINDING_API);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const getCheckLocalDataApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_ME_CHECK_API);
            return resp;
        },
        // eslint-disable-next-line
        []
    );

    const getLocalMeDataApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_ME_API);
            if (resp) return resp;
        },
        // eslint-disable-next-line
        []
    );
    
    const getLocalMeUiRoleApi = useCallback(
        async () => {
            const resp = await Axios.get(GET_ME_UI_ROLE_API);
            if (resp) return resp;
        },
        // eslint-disable-next-line
        []
    )

    return {
        postAuthApi,
        postLiffAuthApi,
        postLoginApi,
        postLiffLoginApi,
        postLiffLoginEmployeeApi,
        getLogoutApi,
        getLiffBindingApi,
        getCheckLocalDataApi,
        getLocalMeDataApi,
        getLocalMeUiRoleApi,
    };
};

export default useAuthApi;
